import { HttpError } from "@coworker/http-client";

type CreateTestbuyErrorCopy = {
  titleKey: string;
  messageKey: string;
};

type CreateTestbuyErrorRule = {
  matches: (error: unknown) => boolean;
  copy: CreateTestbuyErrorCopy;
};

const defaultCreateTestbuyErrorCopy: CreateTestbuyErrorCopy = {
  titleKey: "testbuyCannotBeStartedString",
  messageKey: "testbuyCannotBeStartedDescriptionString",
};

const createHttpErrorMessageMatcher = (
  status: number,
  messageSnippet: string
) => {
  return (error: unknown): boolean => {
    if (!(error instanceof HttpError) || error.status !== status) {
      return false;
    }

    const body = error.body as { message?: unknown } | null;
    return (
      typeof body?.message === "string" && body.message.includes(messageSnippet)
    );
  };
};

const createTestbuyErrorRules: CreateTestbuyErrorRule[] = [
  {
    matches: createHttpErrorMessageMatcher(
      400,
      "has no articles, cannot initialize the testbuy"
    ),
    copy: {
      titleKey: "noArticlesAvailableString",
      messageKey: "noArticlesAvailableDescriptionString",
    },
  },
  {
    matches: createHttpErrorMessageMatcher(
      400,
      "is already linked to a testbuy"
    ),
    copy: {
      titleKey: "testbuyIsAlreadyLinkedString",
      messageKey: "testbuyIsAlreadyLinkedStringDescriptionString",
    },
  },
];

export const mapCreateTestbuyErrorToCopy = (
  error: unknown
): CreateTestbuyErrorCopy => {
  const matchedRule = createTestbuyErrorRules.find((rule) =>
    rule.matches(error)
  );

  return matchedRule?.copy ?? defaultCreateTestbuyErrorCopy;
};
